import { analysisClient, supabase } from "@/shared/lib/supabase";

type CreateStepParams = {
  analysisId: string;
  stepName: string;
  order: number;
  userId: string;
  tenantId: string;
};

const PLACEHOLDER_PROMPT_ID = "00000000-0000-0000-0000-000000000001";

export const analysisStep = {
  update: (stepId: string, value: string) =>
    analysisClient
      .from("analysisstep")
      .update({ value })
      .eq("analysis_step_id", stepId)
      .select("*")
      .single(),

  delete: (stepId: string) =>
    analysisClient.from("analysisstep").delete().eq("analysis_step_id", stepId),

  restartAnalysis: (analysisId: string) =>
    supabase.functions.invoke(`analysis/${analysisId}/restart`, {
      method: "POST",
    }),

  restartStep: (analysisId: string, analysisStepId: string) =>
    supabase.functions.invoke(
      `analysis/${analysisId}/analysisstep/${analysisStepId}/restart`,
      {
        method: "POST",
      },
    ),

  create: ({
    analysisId,
    stepName,
    order,
    userId,
    tenantId,
  }: CreateStepParams) => {
    const nowIso = new Date().toISOString();
    return analysisClient
      .from("analysisstep")
      .insert({
        analysis_id: analysisId,
        analysis_order: order,
        analysis_prompt: null,
        analysis_step_name: stepName,
        prompt_id: PLACEHOLDER_PROMPT_ID,
        record_creator: userId,
        record_updator: userId,
        record_tenant_id: tenantId,
        record_created: nowIso,
        record_updated: nowIso,
        value: "",
      })
      .select("*")
      .single();
  },
};
